import { keyMirror } from '../../global/utils';

export default keyMirror([
	'PROMISE_UPDATE_PREFERENCES',
	'FETCH_PREFERENCES',
	'FETCH_WORKFLOW_DEFINITIONS',
	'ON_TASK_FILTER_CHANGE',
	'ON_WORKFLOW_FILTER_CHANGE',
	'ON_TEMPLATE_FILTER_CHANGE',

	'RESET_FILTERS',
	'RESET_TEMPLATES_FILTERS',
	'RESET_WORKFLOW_FILTERS',
	'RESET_TASK_FILTERS',
	'RESET_TEMPLATES_URL',

	'FETCH_WORKFLOWS',
	'CHANGE_ROUTE',
	'FETCH_TASKS',
	'FETCH_GROUP_TASKS',
	'PROMISE_ON_FORM_SUBMIT',
	'FETCH_WORKFLOW_DATA',
	'FETCH_TASK_FORM',

	'FETCH_EDIT_TEMPLATE_FORM',
	'FETCH_TEMPLATE_FORM',
	'PROMISE_EDIT_TEMPLATE_FORM',
	'CLOSE_EDIT_TEMPLATE_FORM',
	'OPEN_TEMPLATE_FORM',
	'CLOSE_TEMPLATE_FORM',
	'FETCH_TEMPLATES',
	'DELETE_TEMPLATE',
	'UPDATE_TEMPLATE',
	'ADD_TEMPLATE',
	'ON_FORM_CHANGE',
	'CALC_NEXT_DATE',
	'GET_USER_DEVICE',

	//Are defined by constant
	'PROMISE_SET_ASSIGNEE',
	'PROMISE_CLAIM_ASSIGNEE',
	'PROMISE_RELEASE_ASSIGNEE',
	'PROMISE_UPLOAD_PACKAGE_ITEMS',
	'PROMISE_CANCEL_WORKFLOW',
	'PROMISE_SAVE_DOC_META',

	'FETCH_FILES',
	'FETCH_DOCUMENT_DATA',
	'FETCH_DOCUMENT_META',
	'FETCH_DOCUMENT_META_EDIT',

	'SET_FILE',
	'SET_OUTCOME_BUTTON',

	'RESET_STATE',

	'TASK_SUBMIT_START',
	'TASK_SUBMIT_SUCCESS',
	'ON_TAB_CLICK',

	'FETCH_COMMENTS',
	'ON_NEW_FIELD_CHANGE',
	'ON_FIELD_CHANGE',
	'PROMISE_SAVE_NEW_COMMENT',
	'PROMISE_SAVE_COMMENT',
	'PROMISE_DELETE_COMMENT',
	'TOGGLE_NEW_COMMENT_EDIT',
	'TOGGLE_COMMENT_EDIT',

	'FETCH_COMMENTS_NEW',
	'ON_ROWS_PER_PAGE_CHANGE',
	'COMMENTS_FILTER_CHANGE',
	'ON_TAB_CLICK',

	'PROMISE_REMOVE_RELATED_DOC',
	'PROMISE_UPDATE_RELATED_DOCS',
	'FETCH_RELATED_DOCS_AND_ATTACHMENTS',
	'PROMISE_UPLOAD_ATTACHMENT',

	// MY DOCUMENTS
	'FETCH_MY_DOCUMENTS',
	'ON_DOCUMENTS_FILTER_CHANGE',
	'RESET_DOCUMENTS_FILTERS',
]);

export const SORT_PARAMS = {
	asc: {
		//title: 'TaskName_Asc',
		startDate: 'STARTDATE_ASC',
		endDate: 'ENDDATE_ASC',
		dueDate: 'DUEDATE_ASC',
		priority: 'PRIORITY_ASC',
		docCreated: 'DOCCREATED_ASC',
		docName: 'DOCNAME_ASC',
	},
	desc: {
		//title: 'TaskName_Desc',
		startDate: 'STARTDATE_DESC',
		endDate: 'ENDDATE_DESC',
		dueDate: 'DUEDATE_DESC',
		priority: 'PRIORITY_DESC',
		docCreated: 'DOCCREATED_DESC',
		docName: 'DOCNAME_DESC',
	},
};

export const taskHiddenFields = [
	'prop_taskOwner',
	'prop_bpm_priority',
	'prop_bpm_dueDate',
	'prop_Rpa2UserTask_dueDate',
];

export const excludes = '&exclude=' + window.eHiddenWorkflowNames;

export const PAGE_SIZE = 20;

export const priorityOptions = [
	{
		label: window.Alfresco.messages.global['priority.low'],
		value: '3',
	},
	{
		label: window.Alfresco.messages.global['priority.medium'],
		value: '2',
	},
	{
		label: window.Alfresco.messages.global['priority.high'],
		value: '1',
	},
];

export const wfStatusOptions = [
	{
		label: window.Alfresco.messages.global['edocat.workflow.status.initialized'],
		value: 'LAUNCHED',
	},
	{
		label: window.Alfresco.messages.global['edocat.workflow.status.not.initialized'],
		value: 'NOT_LAUNCHED',
	},
	{
		label: window.Alfresco.messages.global['edocat.workflow.status.not.required'],
		value: 'LAUNCH_NOT_REQUIRED',
	},
];

export const periodOptions = [
	{
		label: window.Alfresco.messages.global['edocat.workflow.period.yearly'],
		value: 'YEAR',
	},
	{
		label: window.Alfresco.messages.global['edocat.workflow.period.quarterly'],
		value: 'QUARTER',
	},
	{
		label: window.Alfresco.messages.global['edocat.workflow.period.monthly'],
		value: 'MONTH',
	},
	{
		label: window.Alfresco.messages.global['edocat.workflow.period.weekly'],
		value: 'WEEK',
	},
	{
		label: window.Alfresco.messages.global['edocat.workflow.period.daily'],
		value: 'DAY',
	},
];
